module.exports = __webpack_public_path__ + "img/emoji_71.3e73a616.png";